import { useEffect } from "react";
import LoginForm from "../components/forms/LoginForm";
import "./Login.css";
import { requestTwoFactorCode } from "../api/auth";
import { useMessages } from "../context/MessageContext";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
function LoginPage() {

    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const { addMessage } = useMessages();
    const { isAuthenticated, isVerifying } = useAuth();

    useEffect(() => {
        if (!isVerifying && isAuthenticated) {
            navigate("/blog", { replace: true });
        }
    }, [isAuthenticated, isVerifying, navigate]);

    const resolveRedirectTarget = () => {
        const nextParam = searchParams.get("next");
        if (nextParam && nextParam.startsWith("/") && nextParam !== "/2fa") {
            return nextParam;
        }
        if (location.state?.from?.pathname) {
            const fromPath = location.state.from.pathname;
            if (fromPath.startsWith("/") && fromPath !== "/2fa") {
                return fromPath;
            }
        }
        return "/blog";
    };

    const handleLogin = async (data) => {
        try {
            const { two_factor_token: token } = await requestTwoFactorCode(
                data.username,
                data.password
            );
            sessionStorage.setItem("two_factor_token", token);
            sessionStorage.setItem("two_factor_username", data.username);
            addMessage("success", "Verificatiecode is verzonden.");
            const destination = resolveRedirectTarget();
            const search = destination ? `?next=${encodeURIComponent(destination)}` : "";
            navigate(`/2fa${search}`, { replace: true });
        } catch (error) {
            addMessage("error", "Inloggen mislukt. Controleer je gegevens.");
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-left">
                <div className="auth-ƒorm-container">
                    <LoginForm onSubmit={handleLogin} />
                    <div className="auth-footer">
                        <a href="/">← Terug naar Home</a>
                    </div>
                </div>
                <p className="auth-copy">© Kurtosis B.V.</p>
            </div>

            <div className="auth-right">
                <div className="auth-overlay">
                    <blockquote>
                        “De ervaringen die er toe doen, zijn vaak degene die we nooit wilden
                        hebben, degene waartoe we nooit besloten hadden.”
                    </blockquote>
                    <p className="author">
                        <strong>Alberto Moravia</strong><br />
                        Italiaans schrijver<br />
                        1907–1990
                    </p>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
